import { render, staticRenderFns } from "./RefillProductsTableAdmin.vue?vue&type=template&id=9aa12648&scoped=true"
import script from "./RefillProductsTableAdmin.vue?vue&type=script&lang=js"
export * from "./RefillProductsTableAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aa12648",
  null
  
)

export default component.exports